import { ReactNode } from 'react'
import styled from 'styled-components'

export const CountChip = ({ children }: { children: ReactNode }) => (
  <Chip>{children}</Chip>
)

export default CountChip

const Chip = styled.span`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: ${({ theme }) => theme.text.xs};
  font-weight: 500;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.ink3};
  background: ${({ theme }) => theme.colors.line2};
  border-radius: ${({ theme }) => theme.radii.pill};
  padding: 3px 9px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: none;
  }
`
